// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Checkboxes-control-CheckboxesComparisonRow-CheckboxesComparisonRow-module__compareButton_checkboxes";
export { _1 as "compareButton_checkboxes" }
